import { color } from "csx";

/** UOM colours */
export const brandBlue = color("#094183");
export const brandLightBlue = color("#F2F5F9");
export const brandDarkBlue = color("#012A58");

/** Greys */

export const brandGrey = color("#272727");
export const brandMedGrey1 = color("#575757");
export const brandMedGrey2 = color("#808184");
export const brandLightGrey = color("#f7f7f7");
export const brandBeige = color("#f6f5f3");
export const brandLightBeige = color("#fbfaf9");

/**Other colors */
export const lightBlue = color("#1295ff");
export const niceBlue = color("rgb(191, 224, 241)");
export const beige = color("#f5f5dc");
export const darkYellow = color("#cc9900");

/**Validation */

export const validationGreen = color("#28a745");
export const validationRed = color("#dc3545");

/**Faded Brand Colors */

export const fadedBrandBlue1 = color("#35659e");
export const fadedBrandBlue2 = color("#4074b2");
//For the blue forms
// export const fadedTurquoise = color(`#ecf1f4`);
// export const darkFadedTurquoise = color("#dce4ea");

export const brandRed = color("#e2231b");
export const brandBrightRed = color("#e2231b");
export const brandDarkRed = color("#a7281a");
export const white = color("#ffffff");
export const brandDarkBrown = color("#2d251a");
export const brandOrange = color("#e77622");
export const brandBlack = color("#000000");
